var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { overflow: "auto" } },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isPreview,
                expression: "!isPreview"
              }
            ],
            staticStyle: { width: "fit-content" }
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              _vm._l(_vm.blocks, function(block) {
                return _c(
                  "div",
                  {
                    key: block.pagePart.pagePartName,
                    staticClass: "section",
                    staticStyle: { width: "301px", "margin-right": "5px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-width": "140px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            class: "title" + (_vm.readonly ? " not-click" : ""),
                            staticStyle: { width: "100%" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(block.customLabel || block.sysLabel) +
                                " "
                            )
                          ]
                        ),
                        _c("el-form-item", { attrs: { label: " " } }, [
                          _c(
                            "span",
                            {
                              staticClass: "element-column-text",
                              attrs: { title: _vm.$t("SeaExport.Display") }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "element-column-text",
                              attrs: { title: _vm.$t("SeaExport.Required") }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "element-column-text",
                              staticStyle: { width: "80px" },
                              attrs: {
                                title: _vm.$t("SystemMaintenance.Alias")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Alias")))]
                          )
                        ]),
                        _vm._l(block.uiCustomElementList, function(element) {
                          return _c(
                            "el-form-item",
                            { key: element.pagePartElement.elementName },
                            [
                              _c(
                                "span",
                                {
                                  class: element.isRequire ? "blue" : "",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s(element.sysLabel))]
                              ),
                              _c("el-checkbox", {
                                staticClass: "element-column-content",
                                attrs: {
                                  disabled:
                                    _vm.readonly ||
                                    element.isRequire ||
                                    !element.branchIsDisplay
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onDisplayChange(block, element)
                                  }
                                },
                                model: {
                                  value: element.isDisplay,
                                  callback: function($$v) {
                                    _vm.$set(element, "isDisplay", $$v)
                                  },
                                  expression: "element.isDisplay"
                                }
                              }),
                              _c("el-checkbox", {
                                staticClass: "element-column-content",
                                attrs: { disabled: "" },
                                model: {
                                  value: element.isRequire,
                                  callback: function($$v) {
                                    _vm.$set(element, "isRequire", $$v)
                                  },
                                  expression: "element.isRequire"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "element-column-text",
                                  staticStyle: {
                                    width: "80px",
                                    "pointer-events": "auto"
                                  },
                                  attrs: { title: element.customLabel }
                                },
                                [_vm._v(_vm._s(element.customLabel))]
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]
        ),
        _vm.isPreview
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  gap: "5px",
                  height: "100%"
                }
              },
              _vm._l(_vm.blocks, function(block) {
                return _c(
                  "div",
                  {
                    key: "preview-" + block.pagePart.pagePartName,
                    staticClass: "section",
                    staticStyle: { "flex-grow": "1" }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        " " + _vm._s(block.customLabel || block.sysLabel) + " "
                      )
                    ]),
                    _c("cargo-ag-grid", {
                      attrs: {
                        "grid-options": _vm.getGridOption(block),
                        "row-data": []
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }